import { fetchPageSuccess } from './pagination'
import { dataFetched } from './reducer'

export function extractNodes(page) {
  const { edges } = page
  return edges.map(({ node }) => node)
}

export function mergeActionAsMetadata(
  metadataAttr,
  orignalAction,
  additionalAction
) {
  const metadata = Object.assign({
    ...orignalAction.metadata,
    [metadataAttr]: additionalAction,
  })
  return { ...orignalAction, metadata }
}

export function mergeGraphQLDataInActionMetadata(originalAction, nodes) {
  const dataAction = dataFetched(nodes)
  return mergeActionAsMetadata('graphql', originalAction, dataAction)
}

// Action
export function pageAndDataFetched(listName, page, options) {
  const pageAction = fetchPageSuccess(listName, page, options)
  const nodes = extractNodes(page)
  return mergeGraphQLDataInActionMetadata(pageAction, nodes)
}

export const makeListRehydrator = ({ getListState, getEntityMap }) => state => {
  const entityMap = getEntityMap(state)
  const listState = getListState(state)
  return listState.nodes.map(id => entityMap.get(id))
}
